import styles from "../css/SkeletonLoader.module.scss";

interface Props {
    style?: React.CSSProperties;
}

export function SkeletonBox({ style }: Props) {
    return <div className={styles.skeleton} style={{ ...style }} />;
}
